import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import s from './CouponTotal.scss';
import classnames from 'clsx';
import {shorten} from '../../../domain/utils/shorten';
import {isFreeShippingCoupon} from '../../../domain/utils/coupon';

export enum CouponTotalDataHook {
  CouponTotalRoot = 'CouponTotal.CouponTotalRoot',
  CouponTotalLabel = 'CouponTotal.CouponTotalLabel',
  CouponTotalCode = 'CouponTotal.CouponCode',
  CouponTotalDiscountValue = 'CouponTotal.CouponDiscountValue',
}

export interface CouponTotalProps {
  shouldShowDivider?: boolean;
}

export const CouponTotal = ({shouldShowDivider = true}: CouponTotalProps) => {
  const {t} = useTranslation();
  const {isRTL} = useEnvironment();
  const {cartModel, cartSummary, sideCartCouponAndNote, refactorCouponOnCart} = useControllerProps().cartStore;
  const appliedCoupon = refactorCouponOnCart ? cartModel.coupon : cartSummary?.appliedCoupon || cartModel.coupon;
  const couponAmount = refactorCouponOnCart
    ? cartSummary?.couponDiscount?.amountOff.formattedConvertedAmount
    : cartSummary?.priceSummary?.discount.formattedConvertedAmount ?? cartModel.discount.formattedConvertedAmount;

  const shouldShowDividerClass = (sideCartCouponAndNote && shouldShowDivider) || !sideCartCouponAndNote;

  const getCouponRowValueText = (): string => {
    if (
      refactorCouponOnCart ? cartSummary?.couponDiscount?.isFreeShippingCoupon : isFreeShippingCoupon(appliedCoupon)
    ) {
      return t('cart.summary.discount.free_delivery');
    }
    /* istanbul ignore next */
    if (isRTL) {
      return `${couponAmount}-`;
    }
    return `-${couponAmount}`;
  };

  return (
    <div
      data-hook={CouponTotalDataHook.CouponTotalRoot}
      className={shouldShowDividerClass && classnames(s.divider, s.root)}>
      <dl>
        <dt>
          <span data-hook={CouponTotalDataHook.CouponTotalLabel}>{t('cart.coupon')}</span>{' '}
          <span data-hook={CouponTotalDataHook.CouponTotalCode}>
            {shorten(appliedCoupon.code.toUpperCase(), 10, '...')}
          </span>
        </dt>
        <dd
          data-hook={CouponTotalDataHook.CouponTotalDiscountValue}
          data-wix-coupon-discount-value={CouponTotalDataHook.CouponTotalDiscountValue}>
          {getCouponRowValueText()}
        </dd>
      </dl>
    </div>
  );
};
